import React, { useState, useEffect } from 'react';
import AuthUser from '../../../../../../pageauth/AuthUser';
import PuenteApi from '../../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../../Mensaje';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cargando from '../../../../../../Cargando';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import CryptoJS from 'crypto-js';

export const RW_Config_Modulos = () => {
    require('../../../Remotework.css?v=1.1.0');
    const navigate = useNavigate();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando();
    const { ObtenerEstaciones, ObtenerModulosPorEndpoint, EliminarModulo } = PuenteApi();
    const { getModule, getModuleSector, getApodoSector } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});
    const [modulosPorEstacion, setModulosPorEstacion] = useState({});

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");

        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerModulosDeTodas(parsed);
        } else {
            obtenerEstaciones();
        }
    }, []);

    const obtenerEstaciones = async () => {
        try {
            setLoading(true);

            const response = await ObtenerEstaciones();

            if (response) {
                setEstaciones(response);
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
                await obtenerModulosDeTodas(response);
            }
        } catch (error) {
            console.error("Error al obtener estaciones:", error);
        }
    };

    const obtenerModulosDeTodas = async (listaEstaciones) => {
        const resultados = {};

        for (const estacion of listaEstaciones) {
            try {
                const response2 = await ObtenerModulosPorEndpoint(estacion.endpoint);
                if (response2) {
                    const modulosFiltrados = response2.filter(modulo => modulo.nombre !== "Remotework");
                    if (modulosFiltrados.length > 0) {
                        resultados[estacion.id] = modulosFiltrados;
                    } else {
                        resultados[estacion.id] = [];
                    }
                } else {
                    resultados[estacion.id] = [];
                }
            } catch (error) {
                console.error("Error obteniendo módulos de", estacion.nombre, error);
                resultados[estacion.id] = [];
            }
        }

        setModulosPorEstacion(resultados);
        setLoading(false);
    };

    const handleToggle = (id) => {
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleAgregarModulo = () => {
        navigate('/remotework/configuracion/modulos/agregar');
    };

    const eliminarModulo = async (endpoint, moduloId) => {
        Swal.fire({
            title: '¿Estás seguro?',
            html: "Se eliminara el modulo, los postnet y las manguras asociadas al modulo<br><br>¡Esta acción es irreversible!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminarlo'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await EliminarModulo(endpoint, { id: moduloId });
                    if (response === true) {
                        Swal.fire({
                            title: 'Modulo eliminado',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        obtenerModulosDeTodas(estaciones);
                    } else {
                        Swal.fire({
                            title: 'Error al eliminar modulo',
                            html: response,
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                } catch (error) {
                    console.error("Error al eliminar módulo:", error);
                }
            }
        });
    };


    return (
        <div>
            <div className="container-fluid py-4">
                {loading ? (
                    "Cargando..."
                ) : (
                    <div>
                        <button className="btn btn-primary mb-3" onClick={handleAgregarModulo}>
                            Agregar Nuevo Módulo
                        </button>

                        {estaciones.map((estacion) => (
                            <div key={estacion.id} className="mb-3">
                                <div
                                    onClick={() => handleToggle(estacion.id)}
                                    className="d-flex justify-content-between align-items-center p-3 border rounded cursor-pointer"
                                    style={{
                                        backgroundColor: '#f5f5f5',
                                        borderColor: '#ddd',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                    }}
                                >
                                    <span>{estacion.nombre}</span>
                                    <span>{expanded[estacion.id] ? '▲' : '▼'}</span>
                                </div>

                                {/* Contenido de la estación expandida */}
                                {expanded[estacion.id] && (
                                    <div className="p-3 border mt-2" style={{ backgroundColor: '#fafafa' }}>
                                        {modulosPorEstacion[estacion.id] ? (
                                            modulosPorEstacion[estacion.id].length > 0 ? (
                                                <div className="row row-cols-1 row-cols-md-3 g-4">
                                                    {modulosPorEstacion[estacion.id].map(mod => (
                                                        <div className="col" key={mod.id}>
                                                            <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                                                                <div className="card-body">
                                                                    <h5 className="card-title">{mod.nombre} {mod.sector}</h5>
                                                                    <p>{mod.apodo}</p>
                                                                    <Button style={{ marginRight: '10px' }} variant="warning" onClick={() => navigate("/remotework/configuracion/modulos/configurar", { state: { estacion: estacion, moduloId: mod.id, modulo: mod.nombre, sector: mod.sector, apodo: mod.apodo } })}>Configurar</Button>
                                                                    <Button style={{ marginRight: '10px' }} variant="danger" onClick={() => eliminarModulo(estacion.endpoint, mod.id)}>Eliminar</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p>No se encontraron módulos.</p>
                                            )
                                        ) : (
                                            <p>Cargando módulos...</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div >
    );
};
